import { Button } from "@hortis/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@hortis/ui/dialog";
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@hortis/ui/sheet";
import { useState } from "react";
import type { NewMaterialFormProps } from "src/features/new-material/new-material";
import { NewMaterialForm } from "src/features/new-material/new-material";

type NewMaterialDrawerProps = NewMaterialFormProps & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const NewMaterialDrawer = ({
  open,
  onOpenChange,
  ...props
}: NewMaterialDrawerProps) => {
  const [alertOpen, setAlertOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>New material</SheetTitle>
          <SheetDescription>
            Add a new material to an existing accession.
          </SheetDescription>
        </SheetHeader>
        <SheetBody>
          <NewMaterialForm
            onDiscard={() => {
              setAlertOpen(true);
            }}
            {...props}
          />
        </SheetBody>
      </SheetContent>
      {open && (
        <Dialog open={alertOpen} onOpenChange={setAlertOpen}>
          <DialogTrigger asChild>
            <Button testId="discard-new-material-button" variant="linkgray">
              Discard
            </Button>
          </DialogTrigger>
          <DialogContent data-cy="discord-new-material-dialog">
            <DialogHeader>
              <DialogTitle data-cy="discord-new-material-dialog-title">
                Discard material?
              </DialogTitle>
              <DialogDescription data-cy="discord-new-material-dialog-body">
                The data you&apos;ve entered will be discarded.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose asChild>
                <Button
                  size="lg"
                  fullWidth
                  testId="discard-new-material-cancel"
                >
                  Cancel
                </Button>
              </DialogClose>
              <Button
                size="lg"
                onClick={() => {
                  onOpenChange(false);
                  setAlertOpen(false);
                }}
                variant="warning"
                fullWidth
                testId="discard-new-material-confirm"
              >
                Confirm
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </Sheet>
  );
};
